export enum AvailablePaymentMethodsEnum {
  NotSet = 0, // Ej valt
  Letter = 1, // Faktura via brev
  Email = 2, // Faktura via E-post
  Card = 4, // Kort
  Direct = 8, // Kort / Direktbetalning
  Swish = 16, // Swish
  Autogiro = 32, // Autogiro månadsvis
  FSPay = 64, // FSPay
  AutogiroYear = 128, // Autogiro årsvis
  StripeMonthly = 256, // Stripe månadsvis
  ElectronicInvoice = 512, // E-faktura (företag)
}

// Utility: Kontrollera om en specifik betalmetod (flagga) är aktiv i värdet.
// - Varje betalmetod har ett eget värde i 2-bas (binärt) — t.ex. Swish = 16 = 00010000.
// - paymentMethod är en bitmask: flera metoder kan vara aktiva samtidigt genom att deras binära värden adderas ihop.
// - Exempel: paymentMethod = 191 = 10111111 binärt
//     128 (AutogiroYear) +
//      32 (Autogiro månadsvis) +
//      16 (Swish) +
//       8 (Direktbetalning) +
//       4 (Kort) +
//       2 (Epost) +
//       1 (Brev)
//   = 191
// hasFlag använder bitwise AND (&) för att testa om en specifik flagga finns i paymentMethod.
// (value & flag) === flag
// Om resultatet är lika med flag-värdet betyder det att flaggan är aktiv.
export function hasFlag(value: number | undefined, flag: AvailablePaymentMethodsEnum): boolean {
  if (value === undefined) return false;
  // eslint-disable-next-line no-bitwise
  return (value & flag) === flag;
}

// Descriptions
export const getPaymentMethodDescription = (method: AvailablePaymentMethodsEnum, t: (n: string) => string): string => {
  const translationKeys: Record<AvailablePaymentMethodsEnum, string> = {
    [AvailablePaymentMethodsEnum.NotSet]: t('invoice:adminInvoiceGroupDetailPage.notSet'),
    [AvailablePaymentMethodsEnum.Letter]: t('invoice:adminInvoiceGroupDetailPage.letter'),
    [AvailablePaymentMethodsEnum.Email]: t('invoice:adminInvoiceGroupDetailPage.email'),
    [AvailablePaymentMethodsEnum.Card]: t('invoice:adminInvoiceGroupDetailPage.card'),
    [AvailablePaymentMethodsEnum.Direct]: t('invoice:adminInvoiceGroupDetailPage.direct'),
    [AvailablePaymentMethodsEnum.Swish]: t('invoice:adminInvoiceGroupDetailPage.swish'),
    [AvailablePaymentMethodsEnum.Autogiro]: t('invoice:adminInvoiceGroupDetailPage.autogiro'),
    [AvailablePaymentMethodsEnum.FSPay]: t('invoice:adminInvoiceGroupDetailPage.fsPay'),
    [AvailablePaymentMethodsEnum.AutogiroYear]: t('invoice:adminInvoiceGroupDetailPage.autogiroYear'),
    [AvailablePaymentMethodsEnum.StripeMonthly]: t('invoice:adminInvoiceGroupDetailPage.stripeMonthly'),
    [AvailablePaymentMethodsEnum.ElectronicInvoice]: t('invoice:adminInvoiceGroupDetailPage.electronicInvoice'),
  };

  const key = translationKeys[method] || 'invoice:adminInvoiceGroupDetailPage.notSet';
  return t(key);
};
